import Vue from 'vue';
import { mapGetters } from 'vuex';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import linkItem from './link-item';
import { linkBus } from './link-bus.js';
import { linkShape } from '../../utils';

export default Vue.component('editor-links', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentPage', 'currentSite']),
  },
  components: {
    linkPage,
    linkItem,
  },
  data() {
    return {
      linkLoading: false,
      activeLink: null,
      editLinkForm: false,
      title: '',
    };
  },
  name: 'editor-links',
  props: ['droplet', 'show-edit-bubble'],
  created() {
    linkBus.$on('removeLink', this.removeNavLink);
    linkBus.$on('setActiveLink', this.setFormValues);
  },
  beforeDestroy() {
    linkBus.$off('removeLink', this.removeNavLink);
    linkBus.$off('setActiveLink', this.setFormValues);
  },
  methods: {
    addLink() {
      const newLink = linkShape()();
      const payload = {};
      payload.drp = this.droplet;
      payload.newLink = newLink;
      this.promise(this.$store.dispatch('addNavLink', payload), 'adding nav link');
      // set new link as active in editor
      this.setFormValues(newLink);
    },
    removeNavLink(params) {
      // if link has sublinks, don't allow a deletion
      if (params.link.subLinks.length > 0) {
        return;
      }

      // don't allow if link is on first level and there are no siblings
      // e.g. if the link is the last one left
      if (params.firstLevel && params.links.length < 2) {
        return;
      }

      this.$store.dispatch('spliceDropletVal', {
        array: params.links,
        index: params.index,
      });
      if (this.activeLink && params.link._id === this.activeLink._id) {
        this.resetFormValues();
      }
    },
    bounceLink() {
      this.linkLoading = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          this.linkLoading = false;
          resolve();
        }, 250);
      });
    },
    async setFormValues(link) {
      this.activeLink = link;
      this.editLinkForm = true;
      this.title = link.title;
      await this.bounceLink();
    },
    resetFormValues() {
      this.editLinkForm = false;
      this.title = '';
      this.activeLink = null;
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.resetFormValues();
    },
    drzClickSave() {
      this.resetFormValues();
    },
    updateTitle() {
      const val = this._getInputVal(this.title);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeLink,
        key: 'title',
        val,
      });
    },
    rearrangeLinks(data) {
      const payload = {};
      payload.drp = this.droplet;
      payload.linkId = data.activeId;
      payload.newParentId = data.activeNewParent;
      payload.oldParentId = data.activeOldParent;
      payload.newIndex = data.newIndex;
      payload.oldIndex = data.oldIndex;
      return this.promise(this.$store.dispatch('rearrangeLinks', payload), 'rearranging links');
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in Nav: ${error}`));
        }
      });
      promise.then(() => {
        this.$vnode.context.$parent.$vnode.context.unBindPlugin();
        this.$vnode.context.$parent.$vnode.context.bindPlugin();
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/components/editor-links/index.js